import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const CompletedVoice = () => {
  const [voices, setVoices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10;
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchVoices = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/admin/get/ryv/completed/ads`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        console.log("Completed get new Voices Data:", response);
        setVoices(Array.isArray(response.data.data) ? response.data.data : []);
      } catch (err) {
        setError("Failed to fetch completed voices");
      } finally {
        setLoading(false);
      }
    };
    fetchVoices();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="text-red-500">{error}</div>;

  // Pagination calculations
  const totalPages = Math.ceil(voices.length / rowsPerPage);
  const paginatedVoices = voices.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <>
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <h2 className="text-xl sm:text-2xl font-bold text-gray-800">
          Completed Voices
        </h2>
        <div className="flex flex-wrap gap-2 sm:space-x-2 sm:space-y-0">
          <button
            className="flex-1 sm:flex-none px-3 py-2 sm:px-4 sm:py-2 bg-yellow-500 text-white rounded hover:bg-yellow-600 font-semibold transition-colors text-sm sm:text-base"
            onClick={() => navigate("/admin/pendingvoice")}
          >
            Pending
          </button>
          <button
            className="flex-1 sm:flex-none px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 font-semibold transition-colors text-sm sm:text-base shadow"
            onClick={() => navigate("/admin/runningvoice")}
          >
            Accepted By Reporter
          </button>
          <button
            className="flex-1 sm:flex-none px-3 py-2 sm:px-4 sm:py-2 bg-blue-500 text-white rounded hover:bg-blue-600 font-semibold transition-colors text-sm sm:text-base"
            onClick={() => navigate("/admin/runningvoice")}
          >
            Running
          </button>
          <button
            className="flex-1 sm:flex-none px-3 py-2 sm:px-4 sm:py-2 bg-green-500 text-white rounded hover:bg-green-600 font-semibold transition-colors text-sm sm:text-base"
            onClick={() => navigate("/admin/approvedvoice")}
          >
            Approved
          </button>
        </div>
      </div>
      <div className="w-full max-w-full">
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white rounded-xl shadow-sm border border-gray-100">
            <thead>
              <tr>
                <th className="px-4 py-3 text-left">Voice ID</th>
                <th className="px-4 py-3 text-left">Submitter</th>
                <th className="px-4 py-2 text-left">Description</th>
                <th className="px-4 py-2 text-left">State</th>
                <th className="px-4 py-2 text-left">City</th>
                <th className="px-4 py-2 text-left">Target Audience</th>
                <th className="px-4 py-2 text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {voices.length === 0 ? (
                <tr>
                  <td colSpan="7" className="text-center py-4">
                    No completed voices found.
                  </td>
                </tr>
              ) : (
                paginatedVoices.map((voice) => (
                  <tr key={voice._id} className="border-t">
                    <td className="px-4 py-2">{voice._id}</td>
                    <td className="px-4 py-2">{voice.name || "N/A"}</td>
                    <td className="px-4 py-2">
                      <div className="text-xs text-gray-500 max-w-xs truncate" title={voice.description}>
                        {voice.description || "N/A"}
                      </div>
                    </td>
                    <td className="px-4 py-2">{voice.state}</td>
                    <td className="px-4 py-2 whitespace-nowrap border-b">
                      <div className="text-sm text-gray-500">
                        {Array.isArray(voice.city)
                          ? voice.city.filter(Boolean).join(", ")
                          : voice.city || "N/A"}
                      </div>
                    </td>
                    <td className="px-4 py-2">
                      <span className={`px-2 py-1 rounded-full text-xs font-semibold ${voice.targetUserType === "reporter"
                        ? "bg-blue-100 text-blue-800"
                        : voice.targetUserType === "influencer"
                          ? "bg-purple-100 text-purple-800"
                          : voice.targetUserType === "both"
                            ? "bg-green-100 text-green-800"
                            : "bg-gray-100 text-gray-800"
                        }`}>
                        {voice.targetUserType === "reporter" ? "Reporters Only" :
                          voice.targetUserType === "influencer" ? "Influencers Only" :
                            voice.targetUserType === "both" ? "Both" : "Not Specified"}
                      </span>
                    </td>
                    <td className="px-4 py-2">
                      <span className="px-2 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-800">
                        {voice.status}
                      </span>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
        {/* Pagination Controls */}
        {totalPages > 1 && (
          <div className="flex justify-center items-center mt-6 w-full">
            <nav className="inline-flex flex-wrap items-center gap-2 mx-auto">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={`px-4 py-1 rounded border border-yellow-400 text-yellow-800 bg-white hover:bg-yellow-100 transition-colors font-semibold ${currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''}`}
              >
                Previous
              </button>
              {/* Page number buttons */}
              {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                <button
                  key={page}
                  onClick={() => handlePageChange(page)}
                  className={`px-3 py-1 rounded border border-yellow-400 text-yellow-800 bg-white hover:bg-yellow-100 transition-colors font-bold ${page === currentPage ? 'bg-yellow-300 text-yellow-900' : ''}`}
                  aria-current={page === currentPage ? 'page' : undefined}
                >
                  {page}
                </button>
              ))}
              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={`px-4 py-1 rounded border border-yellow-400 text-yellow-800 bg-white hover:bg-yellow-100 transition-colors font-semibold ${currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : ''}`}
              >
                Next
              </button>
            </nav>
          </div>
        )}
      </div>
    </>
  );
};

export default CompletedVoice;
